export const EN_LPF_STRINGS = {
  RESOURCE_CODE_SYSTEM_CONCEPT_LABEL: 'Cohort',
  RESOURCE_CODE_LABEL: 'LPF Code',
  RESOURCE_DATA_POINT_DEFINITION_LABEL: 'Data Point Definition',
  LESS_THAN: 'Less than',
  GREATER_THAN: 'Greater than',
  POSTAL_CODE: 'Postal Code',
  COUNTRY: 'Country',
  CODE_LABEL: 'Code',
  CODE_HINT: 'e.g adults-v1',
  DEFINITION_LABEL: 'Definition',
  DEFINITION_HINT: 'e.g. Users older than 18 years old ',
  JSON_LOGIC_RULE_LABEL: 'JSON Logic Rule',
  LPF_COHORT_JSON_LOGIC_RULE_AI_PROMPT_PLACEHOLDER:
    'Describe the cohort rule in plain language...',
  CODE_SYSTEM_CONCEPTS: 'Cohorts',
  QUESTIONNAIRE_RESPONSE_STRING: 'Questionnaire response (string / code)',
  QUESTIONNAIRE_RESPONSE_STRING_HINT: 'e.g. LOINC-123',
  QUESTIONNAIRE_RESPONSE_NUMBER: 'Questionnaire response (number)',
  QUESTIONNAIRE_RESPONSE_NUMBER_HINT: 'e.g. 15',
  QUESTIONNAIRE_RESPONSE_DATE: 'Questionnaire response (date)',
  QUESTIONNAIRE_RESPONSE_DATE_HINT: '2025-01-01',
  QUESTIONNAIRE_RESPONSE_CODE: 'Questionnaire response (code)',
  QUESTION_CODES: 'Question Codes',
  USERS_BIRTHDATE: "User's Birthdate",
  USERS_AGE: "User's Age",
  USERS_AGE_HINT: 'e.g. 22',
  USERS_SEX_AT_BIRTH: "User's Sex at birth",
  USERS_LOCATION: "User's Location",
  USERS_LOCATION_HINT: 'e.g. Toronto',
  HEALTH_RISKS: 'Health Risks',
  HEALTH_CAMPAIGN_STATUS: 'Health Campaign Completed',
  HEALTH_CAMPAIGN_STATUS_HINT: 'e.g. User Completed campaign X at least once',
  FAILED: 'Failed',
  IN_PROGRESS: 'In Progress',
  ACTIVITY_STATUS_RULE: 'Activity Status',
  ACTIVITY_STATUS_HINT: 'e.g. User has cancelled activity X at least once',
  LOCATION_DATAPOINT: 'Location',
  DATAPOINT_VALUE: 'Value',
  MATCHING_STRINGS: 'Matching Strings',
  STRING_TO_MATCH: 'Another Match',
  DISTRICT: 'District',
  HEALTH_RISKS_DATAPOINTS: 'Health Risks',
  HEALTH_RISK: 'Health Risk',
  CAMPAIGN_STATUS: 'Campaign Status',
  INACTIVE: 'Inactive',
  QUESTIONNAIRE_OBSERVATION: 'Questionnaire Observation',
  CUSTOMER_PROVIDED_DATAPOINT_TRUE: 'Customer-provided data point is true',
  CUSTOMER_PROVIDED_DATAPOINT_STRING: 'Customer-provided data point (String)',
  CUSTOMER_PROVIDED_DATAPOINT_STRING_HINT: 'example1',
  CUSTOMER_PROVIDED_DATAPOINT_NUMBER: 'Customer-provided data point (Number)',
  CUSTOMER_PROVIDED_DATAPOINT_NUMBER_HINT: '12.2',
  CUSTOMER_PROVIDED_DATAPOINT_DATE: 'Customer-provided data point (Date)',
  CUSTOMER_PROVIDED_DATAPOINT_DATE_HINT: '2025-01-01',
  EXTERNAL_CODE_ELIGIBLE: 'User is eligible for external code',
  EXTERNAL_CODE_ELIGIBLE_HINT: 'CODE-123',
  BIOMETRIC_OBSERVATION: 'Biometric Observation',
  DATAPOINT: 'Data point',
  QUESTION_ID: 'Question ID',
  OPERATOR: 'Operator',
  ANSWER_CODE: 'Answer Code',
  ANSWER_STRING: 'Answer String / Code',
  DESCRIPTION_LABEL: 'Description',
  LABEL_LABEL: 'Label',
  DATATYPE_LABEL: 'Data Type',
  QUERY_LABEL: 'Query',
  PATH_LABEL: 'Path',
  TAGS_LABEL: 'Tags',
  TAG_LABEL: 'Tag',
  LPF_DATA_POINT_DEFINITIONS: 'Data Points',
  LPF_CODE_DEFINITIONS: 'Codes',
  DATA_POINT_DEFINITION_ID: 'Id',
  DATA_POINT_DEFINITION_ID_HINT: 'lpf.loinc.76689-9.value',
  DATA_POINT_DEFINITION_LABEL_HINT:
    'Sex assigned at birth (LOINC: 76689-9) value',
  DATA_POINT_DEFINITION_QUERY_HINT: `/lpf/fhir/Observation?subject:Patient.identifier=$\{{league_user_id}}&code=http://loinc.org|76689-9&status:not=entered-in-error&_sort=-date&_count=1`,
  DATA_POINT_DEFINITION_PATH_HINT: 'Bundle.entry[0].resource.valueString',
  DATA_LPF_CODE_HINT: 'code-123',
  DATA_LPF_LABEL_HINT: 'Code-123',
  DATA_LPF_DESCRIPTION_HINT: 'Users with Observation code-123',
};
